var app = angular.module('leonardo')

var AnalyticsService = function($window, TemplateService, AuthService, deviceDetector) {
  var service = {};
    // Global properties that should be included in every event
  service.getGlobalProperties = function() {
     let properties = {
        environment: $window.LEO_DEPLOY_ENVIRONMENT,
        platform: (deviceDetector.isMobile() || deviceDetector.isTablet()) ? 'mobile web' : 'desktop web',
        user_agent: navigator.userAgent,
        active_feature_gates: StatsigService.getActiveGates(AuthService.user?.statsig_active_gates || []),
      };

      if(AuthService.hasOldToken()){
        properties.working_as_id = AuthService.getDecodedToken()?.user_id;
      }
      return properties;
    }
  
    // Task group properties
    service.getTaskGroupProperties = function(task) {
      var properties = {
        account_id: task.account,
        portfolio_id: task.portfolio,
        property_id: task.property,
        task_id: task.id,
        task_name: task.name,
        template_id: task.template
      };
      if(task.workflow_instance && task.workflow_instance.workflow) {
        properties.workflow_id = task.workflow_instance.workflow;
      }
      return properties;
    };     

    // Workflow group properties
    service.getWorkflowGroupProperties = function(workflow, property, portfolio) {
      return {
        workflow_id: workflow.id,
        workflow_name: workflow.name,
        workflow_date: moment.utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        property_id: property,
        is_unit_workflow: workflow.by_unit,
        account_id: workflow.account,
        portfolio_id: portfolio
      };
    };
  
    // Task details properties
  service.getTaskDetailsProperties = function(task, selectedCategory, selectedSubcategory, selectedRoles, selectedVendorCategories) {
    return {
      approval_step_count: task.approval_steps ? task.approval_steps.length : 0,
      assigned_categories: selectedCategory ? [selectedCategory.name] : [],
      assigned_roles: selectedRoles.map(r => r.name),
      assigned_subcategories: selectedSubcategory ? [selectedSubcategory.name] : [],
      assigned_user_id: task.account_users_assigned.map(u => u.id),
      assigned_vendor_categories: selectedVendorCategories.map(v => v.name),
      dynamic_form_id: task.dynamic_form,
      group_id: task.group,
      has_attachments: !!(task.attachments && task.attachments.length > 0),
      recurrence: task.recurrence_type ? 
        TemplateService.RECURRENCE_OPTIONS.find(opt => opt.id == task.recurrence_type)?.name : null
      };
    }

  // Document Group 
  service.getDocumentGroupProperties = function(document) {
    // Convert underscores back to spaces since BE converts spaces to underscores
    const getOriginalName = (filename) => {
      if (!filename) return '';
      // Remove file extension
      const nameWithoutExt = filename.replace(/\.[^/.]+$/, '');
      return nameWithoutExt.replace(/_/g, ' ');
    };

    return {
      document_id: document.id,
      document_filename: document.name,
      document_name: getOriginalName(document.name),
      document_folder_id: document.folder,
      document_folder_name: (document.breadcrumb && document.breadcrumb.length > 0) ? getOriginalName(document.breadcrumb[document.breadcrumb.length - 1].name) : '',
    };
  };


  // Work order Group properties
  service.getWorkOrderGroupProperties = function(workOrder, authData) {
    return {
      work_order_id: workOrder.id,
      work_order_name: workOrder.brief_description,
      property_id: workOrder.property,
      account_id: workOrder.account || authData?.account?.id,
      portfolio_id: workOrder.portfolio,
      unit_name: workOrder.unit_name,
      priority: workOrder.priority,
      assigned_in_leo: workOrder.account_users_assigned,
      unit_id: workOrder.unit_id
    };
  }

  // Calculate days late utility
  service.calculateDaysLate = function(dueDate) {
    const today = moment().startOf('day');
    const due = moment(dueDate).startOf('day');
    
    if (due >= today) {
      return 0;
    }
    
    return today.diff(due, 'days');
  };

  // Identify user
    service.identifyUser = function(user, authData) {
      if(!$window.analytics) return;

      if(AuthService.hasOldToken()) {
        const oldUser = JSON.parse(localStorage.getItem('jwt_old_user'));
        user = oldUser;
      }
      const roles = [...new Set(
        (user.account_users ?? [])
          .map(account_user => account_user.role?.name)
          .filter(roleName => roleName != null)
      )];
        
      const traits = {
        account: !AuthService.hasOldToken() && authData?.account?.name || '',
        account_id: authData?.account?.id,
        email: user.email,
        is_multi_account: AuthService.hasOldToken() || (authData?.accountsManager?.length > 1) || false,
        name: user.first_name + ' ' + user.last_name,
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        date_joined: user.date_joined || '',
        role: roles,
        title: user.title || '',
      };
      if(!$window.analytics) return;
      $window.analytics.identify(user.id, traits, service.getGlobalProperties());
    };

    // track events
    service.track = function(eventName, properties = {}) {
      if(!$window.analytics) return;
      $window.analytics.track(eventName, {
        ...service.getGlobalProperties(),
        ...properties
      });
    };

    return service;
  };

  app.factory('AnalyticsService', ['$window', 'TemplateService', 'AuthService', 'deviceDetector', AnalyticsService]);